import { SharedService } from './../../services/shared.service';
import { Component, OnInit, Input } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { SessionService } from '../common/session/session.service';

@Component({
  selector: 'social-networks-links',
  templateUrl: './social-networks-links.component.html',
  styleUrls: ['./social-networks-links.component.scss']
})
export class SocialNetworksLinksComponent implements OnInit {
  eventData:any = {};
  @Input()
  exhibitor:any={};
  @Input()
  product:any={};
  @Input()
  socialNetworks:Array<any> = [];
  @Input()
  isHome:boolean=false;
  @Input()
  listView:string="grid";

  isShareModalDisplayed:any=false;
  social:any;
  mobile: boolean = false;

  constructor( public utilsService:UtilsService, private sessionService: SessionService, private sharedService:SharedService) {
  }

  toggleShareModal() {
    this.isShareModalDisplayed=!this.isShareModalDisplayed;
  }

  getUrl():string {
    const productId = this.product.entityId || this.product.idProduct || this.product.id;
    const exhibitorId = this.exhibitor.entityId || this.exhibitor.idExhibitor || this.exhibitor.id;
    if(!!productId) {
      return `${document.location.protocol}//${document.location.host}/${this.eventData.eventName}/product/${productId}/detail`;
    }
    if(!!exhibitorId) {
      return `${document.location.protocol}//${document.location.host}/${this.eventData.eventName}/exhibitor/${exhibitorId}/detail`;
    }
    return document.location.href;
  }

  getTags() {
    return this.eventData.hashtags;
  }

  obtainDescription() {
    const prodTr = this.product.translations || this.product.productTranslation;
    const exTr = this.exhibitor.translations || this.exhibitor.exhibitorDescription;
    if(!!prodTr) {
      return `${this._('social.product.message', 'social.product.message')} ${this._api(prodTr, 'description')}`;
    }
    if(!!exTr) {
      return `${this._('social.exhibitor.message', 'social.exhibitor.message')} ${this._api(exTr, 'description')}`;
    }
    return "";
  }

  _(s, a){
    return '';
  }

  _api(transition, property){
    return this.utilsService._api(transition, property);
  }

  ngOnInit() {
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    this.sharedService.getIsMobile().subscribe(arg => this.mobile = arg);
  }

  
  /**
   * [fixTwitterUrl Transforms an "@username" text into a twitter URL]
   * @param  {string} url [Original URL]
   * @return {string}     [Full URL]
   */
  fixTwitterUrl(url:string):string {
    // Si ya tiene protocolo https:// o http://, devolver tal cual
    if (url.match(/^https?:\/\//i)) {
      return url;
    }
    // Si comienza con @, construir URL con el username
    if (url.substring(0,1) === "@") {
      return "https://twitter.com/" + url.substr(1);
    }
    // Si ya contiene el dominio de twitter pero sin protocolo, solo añadir https://
    if (url.includes('twitter.com') || url.includes('x.com')) {
      return "https://" + url;
    }
    // Si es solo un username, construir la URL completa
    return "https://twitter.com/" + url;
  }

  /**
   * [fixInstagramUrl Transforms an "@username" text into a instagram URL]
   * @param  {string} url [Original URL]
   * @return {string}     [Full URL]
   */
  fixInstagramUrl(url:string):string {
    // Si ya tiene protocolo https:// o http://, devolver tal cual
    if (url.match(/^https?:\/\//i)) {
      return url;
    }
    // Si ya contiene el dominio de instagram pero sin protocolo, solo añadir https://
    if (url.includes('instagram.com')) {
      return "https://" + url;
    }
    // Si es solo un username (con o sin @), construir la URL completa
    const username = url.startsWith('@') ? url.substring(1) : url;
    return "https://instagram.com/" + username;
  }

  /**
   * [fixFacebookUrl Transforms an "@username" text into a facebook URL]
   * @param  {string} url [Original URL]
   * @return {string}     [Full URL]
   */
  fixFacebookUrl(url:string):string {
    // Si ya tiene protocolo https:// o http://, devolver tal cual
    if (url.match(/^https?:\/\//i)) {
      return url;
    }
    // Si ya contiene el dominio de facebook pero sin protocolo, solo añadir https://
    if (url.includes('facebook.com') || url.includes('fb.com')) {
      return "https://" + url;
    }
    // Si es solo un username, construir la URL completa
    return "https://www.facebook.com/" + url;
  }

  /**
   * [fixLinkedInUrl Transforms a username text into a LinkedIn URL]
   * @param  {string} url [Original URL]
   * @return {string}     [Full URL]
   */
  fixLinkedInUrl(url:string):string {
    // Si ya tiene protocolo https:// o http://, devolver tal cual
    if (url.match(/^https?:\/\//i)) {
      return url;
    }
    // Si ya contiene el dominio de linkedin pero sin protocolo, solo añadir https://
    if (url.includes('linkedin.com')) {
      return "https://" + url;
    }
    // Si es solo un username, construir la URL completa
    return "https://www.linkedin.com/in/" + url;
  }

  /**
   * [fixPinterestUrl Transforms a username text into a Pinterest URL]
   * @param  {string} url [Original URL]
   * @return {string}     [Full URL]
   */
  fixPinterestUrl(url:string):string {
    // Si ya tiene protocolo https:// o http://, devolver tal cual
    if (url.match(/^https?:\/\//i)) {
      return url;
    }
    // Si ya contiene el dominio de pinterest pero sin protocolo, solo añadir https://
    if (url.includes('pinterest.com')) {
      return "https://" + url;
    }
    // Si es solo un username, construir la URL completa
    return "https://www.pinterest.com/" + url;
  }
}
